import script from "./VisitePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VisitePage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__